import { Clock } from '@phosphor-icons/react'
import CustomModal from 'components/global/CustomModal'
import { convertMinutesToLocalTime } from 'helper/utility'
import moment from 'moment'
import React from 'react'
import { EventTimingType } from 'types/globalTypes'

interface ScheduleModalProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  datesOfEvent: string[]
  timings: EventTimingType
}

const ScheduleModal: React.FC<ScheduleModalProps> = ({
  openModal,
  setOpenModal,
  datesOfEvent,
  timings,
}) => {
  const dateToday = moment(new Date()).format('MMM DD, YYYY')
  let timeArr = []

  datesOfEvent.map(eachDay => {
    let updateTimeArr

    if (timings.specialSchedules.length > 0) {
      const specialSchedule = timings.specialSchedules.find(
        // (item) => (item.day) === eachDay
        item =>
          moment(item.day).format('YYYY-MM-DD') ===
          moment(eachDay).format('YYYY-MM-DD'),
      )
      if (specialSchedule) {
        updateTimeArr = [
          ...timeArr,
          {
            date: moment(eachDay).format('MMM DD YYYY'),
            startTime: convertMinutesToLocalTime(specialSchedule?.startTime),
            endTime: convertMinutesToLocalTime(specialSchedule?.endTime),
          },
        ]
      } else {
        updateTimeArr = [
          ...timeArr,
          {
            date: moment(eachDay).format('MMM DD, YYYY'),
            startTime: convertMinutesToLocalTime(timings?.startTime),
            endTime: convertMinutesToLocalTime(timings?.endTime),
          },
        ]
      }
    } else {
      updateTimeArr = [
        ...timeArr,
        {
          date: moment(eachDay).format('MMM DD, YYYY'),
          startTime: convertMinutesToLocalTime(timings?.startTime),
          endTime: convertMinutesToLocalTime(timings?.endTime),
        },
      ]
    }

    timeArr = updateTimeArr
  })

  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={setOpenModal}
        title="Schedule"
        footer={false}
      >
        <p>Date with time of the event</p>

        <div className="px-10px">
          {timeArr.map((item, index) => {
            return (
              <div className="flex justify-between mt-15px" key={index}>
                <h6
                  className={`text-14 ${
                    dateToday === item.date ? 'w-600' : 'w-400'
                  }`}
                >
                  {item.date}
                </h6>
                <div className="flex align-center gap-10px">
                  <Clock size={20} color="#000" />
                  <p
                    className={`text-14 ${
                      dateToday === item.date ? 'b1' : 'b3'
                    }`}
                  >
                    {item.startTime} - {item.endTime}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </CustomModal>
    </>
  )
}

export default ScheduleModal
